import React from 'react';
import { Link } from 'react-router-dom';

import { Content } from './styledComponents';

export default function Navbar() {
  return (
    <Content>
      <Link to="/">
        <img
          className="logo"
          src="/images/logo-new.png"
          alt="Logo PrestaVale blanco"
        />
      </Link>
      <nav className="actions">
        <a href="/registro">¡Regístrate ahora!</a>
      </nav>
    </Content>
  );
}
